import DealerDetailsContainer from "./dealer-details.container";

export default DealerDetailsContainer;